module.exports = __webpack_public_path__ + "static/media/2.466b30fa.jpg";